/**
 * Construye un endpoint concatenando las partes disponibles.
 * Soporta:
 *  - Uso clásico: { id, action }
 *  - Uso extendido con segments adicionales
 *
 * @param {string} base - Ruta base del endpoint.
 * @param {Object} [config={}]
 * @param {string|number} [config.id] - Identificador del recurso.
 * @param {string} [config.action] - Acción sobre el recurso.
 * @param {Array<string|number>} [segments=[]] - Segmentos adicionales del endpoint.
 *
 * @returns {string} Endpoint resultante terminado en '/'.
 */
export const buildEndpoint = (base, { id, action } = {}, segments = []) => {
  return [base, id, action, ...segments].filter(Boolean).join('/') + '/';
};
